import { BASE_URL } from "../utils/constants";
import handler from "../utils/handler";
import { clearAllLocalStorage } from '../utils/localStorageManager';

export const PostNewClient = async(value) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {
		
		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/core/clients`, {
			method: "POST",
			headers,
			body: JSON.stringify(value)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		const data = await response.json();

		return {response, data};

	} catch (e) {
		throw e;
	}
}

export const PostNewClientAll = async(value) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/core/clients/all`, {
			method: "POST",
			headers,
			body: JSON.stringify(value)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		const data = await response.json();

		return {response, data};

	} catch (e) {
		throw e;
	}
}

export const GetClientDetails = async(value) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(value ? `${BASE_URL}/core/clients?filter=${value}` : `${BASE_URL}/core/clients`, {
			method: "GET",
			headers,
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		let result = handler(response)

		return result;

	} catch (e) {
		throw e;
	}
}

export const GetClientInformation = async(value) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/client/${value}`, {
			method: "GET",
			headers,
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		let result = handler(response)

		return result;

	} catch (e) {
		throw e;
	}
}

export const GetBusinessInformation = async(value) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/client/${value}/sellerbusiness`, {
			method: "GET",
			headers,
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		let result = handler(response)

		return result;

	} catch (e) {
		throw e;
	}
}

export const GetBankInformation = async(value) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/client/${value}/sellerbank`, {
			method: "GET",
			headers,
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		let result = handler(response)

		return result;

	} catch (e) {
		throw e;
	}
}

export const GetClientDocumentsTypes = async(businessId) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/client/business/${businessId}/onboardingDocuments`, {
			method: "GET",
			headers,
		});

		let result = handler(response)

		return result;

	} catch (e) {
		throw e;
	}
}

export const GetClientDocuments = async(businessId, category) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/core/attachments/${businessId}/${category}`, {
			method: "GET",
			headers,
		});

		if (response.status === 200) {
			return await response.blob();
		} else {
			return response;
		}
		

	} catch (e) {
		throw e;
	}
}


export const UpdateClientInformation = async(payload) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/client`, {
			method: "PUT",
			headers,
			body: JSON.stringify(payload)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		const data = await response.json();

		return {response, data};

	} catch (e) {
		throw e;
	}
}

export const UpdateBusinessInformation = async(payload) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/client/sellerbusiness`, {
			method: "PUT",
			headers,
			body: JSON.stringify(payload)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		const data = await response.json();

		return {response, data};

	} catch (e) {
		throw e;
	}
}

export const UpdateBankInformation = async(payload) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		let response = await fetch(`${BASE_URL}/admin/client/sellerbank`, {
			method: "PUT",
			headers,
			body: JSON.stringify(payload)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		const data = await response.json();

		return {response, data};

	} catch (e) {
		throw e;
	}
}

export const UpdateDocuments = async(payload, businessId, documentType) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}
		
		let response = await fetch(`${BASE_URL}/core/attachments/${businessId}/${documentType}/status`, {
			method: "POST",
			headers,
			body:  JSON.stringify(payload)
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		let result = handler(response)

		return result;

	} catch (e) {
		console.log(e)
		throw e;
	}
}

export const ReuploadDocuments = async(payload, businessId, documentType) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}

		const formData = new FormData();
		formData.append('image', payload);
		
		let response = await fetch(`${BASE_URL}/core/attachments/${businessId}/${documentType}`, {
			method: "POST",
			headers,
			body: formData
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		let result = handler(response)

		return result;

	} catch (e) {
		console.log(e)
		throw e;
	}
}

export const ApproveClient = async(businessId) => {
	const accessToken = sessionStorage.getItem('accessToken')
	try {

		const headers = {
			"Content-Type": "application/json",
		}
		
		if (accessToken) {
			headers.Authorization = `Bearer ${accessToken}`
		}
		
		let response = await fetch(`${BASE_URL}/admin/client/business/${businessId}/approve`, {
			method: "POST",
			headers,
		});

		if (response.status === 401) {
			clearAllLocalStorage();
		};

		const data = await response.json();

		return {response, data};

	} catch (e) {
		throw e;
	}
}

